export enum UNITS_ENUM{
    Kb = 'Kb',
    Mb = 'Mb'
}